export const getMyCreditBalance = /* GraphQL */ `
  query getMyCreditBalance {
    getMyCreditBalance {
      total
      free
      subscription
      purchased
      subscriptionTier
    }
  }
`;

export const getMyCreditUsage = /* GraphQL */ `
  query getMyCreditUsage($days: Int) {
    getMyCreditUsage(days: $days) {
      date
      creditsUsed
      visualSearchCount
      priceMonitoringCount
      aiEnhancementCount
      exportCount
    }
  }
`;

export const getCreditPlans = /* GraphQL */ `
  query getCreditPlans {
    getCreditPlans {
      id
      tier
      displayName
      monthlyCredits
      monthlyPrice
      yearlyPrice
      stripePriceIdMonthly
      stripePriceIdYearly
      features
      isActive
    }
  }
`;

export const getCreditPackages = /* GraphQL */ `
  query getCreditPackages {
    getCreditPackages {
      id
      name
      credits
      displayPrice
      stripePriceId
      bonusPercentage
      isActive
    }
  }
`;

export const searchCreditTransactions = /* GraphQL */ `
  query searchCreditTransactions(
    $filter: SearchableCreditTransactionFilterInput
    $aggregates: [SearchableCreditTransactionAggregationInput]
  ) {
    searchCreditTransactions(filter: $filter, aggregates: $aggregates) {
      aggregateItems {
        name
        result {
          ... on SearchableAggregateBucketResult {
            __typename
            buckets {
              doc_count
              key
            }
          }
        }
      }
      items {
        amount
        operation
        createdAt
        type
      }
    }
  }
`;
